// import headerImg1 from "../assets/img/head__img05.jpg"
// import headerImg2 from "../assets/img/head__img06.jpg"
// import headerImg3 from "../assets/img/head__img03.jpg"
// import headerImg4 from "../assets/img/head__img04.jpg"
// import headerImg5 from "../assets/img/head__img01.jpg"
// import headerImg6 from "../assets/img/head__img02.jpg"
import port1 from "../assets/img/port01.png"
import port2 from "../assets/img/port02.png"
import port3 from "../assets/img/port03.png"
import port4 from "../assets/img/port04.png"

export const headerNav = [
    {
        title: "About Me",
        url: "#section2",
    },
    {
        title: "Project",
        url: "#section3",
    },
    {
        title: "Contact",
        url: "#section5",
    },
]

// export const headerImg = [
//     {
//         frontImg: headerImg1,
//         behindImg: headerImg2,
//     },
//     {
//         frontImg: headerImg3,
//         behindImg: headerImg4,
//     },
//     {
//         frontImg: headerImg5,
//         behindImg: headerImg6,
//     },
// ]

export const headerImg = [0, 1, 2];

export const toolTips = [
    {
        tag: "Adorable",
    },
    {
        tag: "Incredible",
    },
    {
        tag: "Bubbly",
    },
    {
        tag: "Creative",
    },
    {
        tag: "Enthusiastic",
    },
]

export const phrases = [

    "놀라운 성과와 사랑스러운 매력을 두루 갖춘 열정적인 개발자를 목표로",

    "밝은 에너지로 상황을 긍정적으로 바꾸며, 끊임없이 웹 프론트엔드 솔루션을 창조하기 위해 노력합니다."

]

export const chars = [
    "I", "n", "c", "r", "e", "d", "o", "r", "a", "b", "l", "e",
]

export const lineText = [
    {
        text: "Potencial",
    },
    {
        text: "Creativity",
    },
    {
        text: "Sensibility",
    },
]

export const siteText = [
    {
        img: port1,
        title: "Image_Quiz",
        content: "JavaScript를 이용해 개발한 '이미지 퀴즈' 웹사이트는 사용자들이 즐겁게 일반 상식을 테스트할 수 있는 플랫폼입니다. 직관적인 이미지 선택을 통해 사용자가 문제를 빠르고 쉽게 이해할 수 있도록 디자인하였습니다.",
        time: "3 weeks",
        tag: ["Javascript", "Quiz", "Team"],
        view: "https://coconutpalmtreeisland.github.io/Image_Quiz/quizIntro.html",
        code: "https://github.com/Coconutpalmtreeisland/Image_Quiz",
    },
    {
        img: port2,
        title: "Rusuk_youtube",
        content: "'해루석'의 다양한 활동을 한 눈에 볼 수 있는 웹사이트를 React를 이용해 개발하였습니다. 유튜브 API를 활용해 다양한 형태의 콘텐츠를 제공하며, Postman을 활용한 효율적인 테스트와 디버깅으로 안정적인 서비스를 제공하였습니다. 또한, React의 컴포넌트 기반 아키텍처를 이용해 유지 관리가 용이하고 재사용성이 높은 코드를 작성하였습니다.",
        time: "2 weeks",
        tag: ["React", "Vercel", "API"],
        view: "https://rusuk-react-youtube.vercel.app/",
        code: "https://github.com/Coconutpalmtreeisland/rusuk-react-youtube",
    },
    {
        img: port3,
        title: "Sexy Brain",
        content: "PHP와 MySQL을 활용해 '뇌섹남녀' 웹사이트를 제작하였습니다. 이 웹사이트는 '문제적남자'의 다양한 문제들을 온라인에서 풀 수 있는 플랫폼이며, 사용자 친화적인 회원가입 및 로그인 시스템, 커뮤니티 기능, '좋아요' 기능 등을 통해 개인화된 사용자 경험을 제공하였습니다. 또한, 문제를 푼 후 자신의 성과를 확인할 수 있는 랭킹 시스템을 도입하여 경쟁 요소를 추가하였습니다.",
        time: "1 month",
        tag: ["PHP", "MySQL", "Team"],
        view: "http://incredorable12.dothome.co.kr/project/sexyBrain/home/main.php",
        code: "https://github.com/Coconutpalmtreeisland/SexyBrain",
    },
    {
        img: port4,
        title: "Promptivortex",
        content: "창의적인 프롬프트를 발견하고, 생성하고, 공유하기 위한 오픈소스 AI 프롬프트 사이트입니다. 구글 계정으로 로그인하여 프롬프트를 공유하기 위해 글을 작성할 수 있는 사이트입니다. 내용 및 태그, 사용자 이름으로 검색 가능하며 태그를 클릭하거나 프로필을 클릭해서 해당 글을 모아서 볼 수 있습니다.",
        time: "3 days",
        tag: ["Next.js", "MongoDB", "Vercel"],
        view: "https://real-next-prompt.vercel.app/",
        code: "https://github.com/Coconutpalmtreeisland/real_next_prompt",
    },
]